import React from 'react';

import classNames from 'classnames';
import { Link } from 'react-router-dom';

import { employeeAnnouncementsRoute } from '../../web-routes';

type AnnouncementStylingOptions = {
  announcement?: Announcement | null;
  allowLinkToAnnouncement?: boolean;

  isAnnouncement?: boolean;
  isInbound?: boolean;
  isAutomated?: boolean;
  announcementGroupLabelOnClick?: () => void;
};

export const AnnouncementStyling = ({
  announcement,
  allowLinkToAnnouncement,
  isAnnouncement,
  isInbound,
  isAutomated,
  announcementGroupLabelOnClick,
}: AnnouncementStylingOptions) => {
  const announcementGroupName = announcement
    ? ` to ${announcement.EmployeeGroup?.name || 'all employees'}`
    : '';

  const announcementGroupLabel = () => {
    if (!isAnnouncement || !announcement) {
      return null;
    }

    if (allowLinkToAnnouncement) {
      return (
        <Link
          className="typo-link"
          to={employeeAnnouncementsRoute(
            announcement?.orgId,
            announcement?.EmployeeGroup?.employeeGroupId,
          )}
        >
          {announcementGroupName} as an announcement
        </Link>
      );
    }

    return announcementGroupLabelOnClick ? (
      <span role="presentation" className="typo-link" onClick={announcementGroupLabelOnClick}>
        {announcementGroupName} as an announcement
      </span>
    ) : (
      <span>{announcementGroupName} as an announcement</span>
    );
  };

  // Can be removed with PROD-4039
  const backgroundClass = classNames({
    'u-background-announcement': isAnnouncement,
    'u-background-inboundMessage': isInbound,
    'u-background-outboundMessage': !isAnnouncement && !isInbound && !isAutomated,
    'u-background-automatedMessage': !isAnnouncement && !isInbound && isAutomated,
  });

  return {
    announcementGroupLabel,
    backgroundClass,
  };
};
